export const EventNames: any = {
	eventUpdated: 'event:updated',
    eventDeleted: 'event:deleted',
	userLoginRequired: 'userLoginRequired',
    userLoggedIn: 'userLoggedIn',
    profileCreated: 'user:profile:created'
}


// WEBPACK FOOTER //
// ./src/lib/eventNames.ts